export const ROLES_SWITCH_BAR_TEXT: {
  SWITCH_ROLE: string;
  NAMING: Record<string, string>;
} = {
  SWITCH_ROLE: 'Switch Your Role',

  NAMING: {
    SUPERVISOR: 'Supervisor',

    RIGHT_DO_RPG_S: 'DoRPgS',
    RIGHT_DO_RPG_S_SEC: 'DoRPgS Secretary',
    RIGHT_DO_RPG_S_GO: 'DoRPgS GO',

    RIGHT_INTERVIEW_PANEL: 'Interview Panel',

    RIGHT_DRC_CHAIR: 'DRC Chair',
    RIGHT_DRC_SEC: 'DRC Secretary',
    RIGHT_DRC: 'DRC Member',
    RIGHT_DRC_GO: 'DRC GO',

    RIGHT_FRC: 'FRC Member',
    RIGHT_FRC_CHAIR: 'FRC Chair',
    RIGHT_FRC_GO: 'FRC GO',
    RIGHT_FRC_SEC: 'FRC Secretary',

    RIGHT_GS: 'GS Member',
    RIGHT_GSB: 'GSB Member',
    RIGHT_GSB_CHAIR: 'GSB Chair',
    RIGHT_GSB_GO: 'GSB GO',
    RIGHT_GSB_SEC: 'GSB Secretary',

    RIGHT_PANEL: 'Panel Member',
    RIGHT_AR: 'AR Member',
    RIGHT_HOD_DOS: 'HoD/DoS',
    RIGHT_HOD_DOS_SEC: 'HoD/DoS Secretary',
    RIGHT_VPRI: 'VPRI',
  },
};
